import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { DataCatalogSelector } from 'modules/ai_reports/components/DataCatalogSelector/DataCatalogSelector'
import { useDataCatalogSelector } from 'modules/ai_reports/components/DataCatalogSelector/useDataCatalogSelector'
import { Layout } from 'modules/ai_reports/components/Layout'
import { getSlugFromTableId } from 'modules/ai_reports/lib/slug-tableid-mapping'
import { useSlugToSourceId } from 'modules/ai_reports/lib/useSlugToSourceId'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const DataCatalogPage = () => {
  const { pathname } = useLocation()

  const isNewReport = pathname.endsWith('/new')

  const { slug } = useParams()

  const { datasources, loading, error } = useDataCatalogSelector()

  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const onSelectDatasource = (sourceId: string) => {
    navigate(navigation.aiReports.catalog.slug.fullPath({ slug: getSlugFromTableId(sourceId) }))
  }

  const { sourceId, loading: loadingSourceId } = useSlugToSourceId(slug)

  return (
    <ResponsivePage.Body
      variant="fullscreen"
      loading={loading || loadingSourceId}
      error={error}
      height="full"
    >
      {isNewReport ? (
        <Outlet />
      ) : (
        <Layout>
          {/* Hack to make the page full height */}
          <DataCatalogSelector
            showActions
            onSelectDatasource={onSelectDatasource}
            datasources={datasources}
            sourceId={sourceId}
          />
        </Layout>
      )}
    </ResponsivePage.Body>
  )
}

export default DataCatalogPage
